import React from "react";
import {ImprintButtons} from "./ImprintButtons";

export function Imprint() {
    // https://www.termsofservicegenerator.net/download.php?lang=en&token=62I9LDi0smDCglshk2xgfLSqJG7b3qjH
    return (
        <div id={"imprint"}>
            <div className={"contentWrapper"}>
                <ImprintButtons />
                <h1>Impressum</h1>

                <h2>Address</h2>

                <p>Yacht.Chat GbR</p>
                <p>Danilo Walenta</p>
                <p>Robert-Bosch-Straße 7</p>
                <p>64293 Darmstadt</p>
                <p>Germany</p>

                <h2>Legal form</h2>

                <p>Gesellschaft bürgerlichen Rechts (GbR)</p>

                <h2>Contact</h2>

                <p>E-Mail:</p>
                <p><a href={"mailto:contact@yacht.chat"}>contact@yacht.chat</a></p>
                <p>Tel:</p>
                <p>+49 6151 3929500</p>
                <p>Available daily between 8am (CET) and 6pm (CET)</p>
            </div>
        </div>
    )
}
